<script>
  import { auth, db } from "../etc/firebase.js"
  import { userGuaCount, userStore, guaRecordStore } from "../etc/store.js"
  import AesCtr from "../etc/aes-ctr.js"
  import Keypad from "./KeyPad.svelte"
  import GuaSummary from "./GuaSummary.svelte"
  import marked from "marked"
  import {
    buildComment,
    backToTop,
    scrollToId,
    stickReduction,
    categories,
    btn_style_yellow_d2,
    xiyiSalt,
  } from "../etc/helpers.js"

  let sectionName = "HandQi"

  let guaCount = 0

  const today = new Date(Date.now())
  let qiGuaDate = [
    today.getFullYear(),
    pad(today.getMonth() + 1, 2),
    pad(today.getDate(), 2),
  ].join("-")

  let questionStatement = ""
  let name
  let guaComment

  function convertToDate(str) {
    const split = str.split("-")
    return new Date(+split[0], +split[1] - 1, +split[2])
  }

  function pad(x, len) {
    x = String(x)
    while (x.length < len) x = `0${x}`
    return x
  }

  export let toGuaResult = ""

  document.addEventListener("DOMContentLoaded", function () {
    var elems = document.querySelectorAll(".datepicker")
    var instances = M.Datepicker.init(elems)
  })

  // Listen for auth status change
  let isLogin = false
  let createdDT = ""
  let userName = ""
  let firebaseUid = ""
  let guaNumbers = ""
  let qiGuaDT = ""
  let recorder = ""
  let qiGuaPerson = ""
  let guaType = "hand"
  let question = ""
  // let copy_question = ""
  let category = ""
  let tag = []
  let new_tag = ""
  let tagString = ""
  let tagAdded = false
  let explanation = ""
  let ranking = ""
  let comment = []
  let recordDT = ""
  let guaSubmitted = false

  // Listen for auth status change
  $: if ($userStore.isLogin == true) {
    isLogin = true
    firebaseUid = $userStore.userInfo.firebaseUid
    userName = $userStore.userInfo.userName
    recorder = userName
    qiGuaPerson = userName
    // console.log("@ HandQi: getting firebaseUid : ", firebaseUid)
    // console.log("@ HandQi: getting userName : ", userName)
  } else {
    isLogin = false
  }

  let pin = ""
  $: view = pin ? pin : "請輸入卦數..."

  let pinColor = ""
  $: pin.length == 6 ? (pinColor = "#1b5e20") : (pinColor = "#f44336")

  let requiredFieldReady = false
  $: qiGuaDT != "" && question != "" && category != "" && qiGuaPerson != ""
    ? (requiredFieldReady = true)
    : (requiredFieldReady = false)

  let numStr = "To be entered..."

  let copy_qiGuaDT = ""
  let copy_qiGuaPerson = ""
  let copy_guaNumbers = ""
  //let copy_explanation = ""
  let copy_question = ""
  let copy_category = ""
  let copy_tag = []
  let copy_new_tag = ""
  let copy_ranking = ""
  //  let copy_comment = ""
  let copy_pin = ""

  let summaryObj = []
  $: guaSubmitted
    ? (summaryObj = [
        // { title: "登錄日期", data: new Date(recordDT) },
        // { title: "登錄人", data: recorder },
        { title: "起卦日期", data: new Date(copy_qiGuaDT) },
        { title: "起卦人", data: copy_qiGuaPerson },
        { title: "問題", data: copy_question },
        { title: "類別", data: copy_category },
        { title: "卦數", data: copy_guaNumbers },
        // { title: "解卦", data: // },
        // { title: "筆記", data: //copy_comment },
      ])
    : (summaryObj = [])

  let newExplanation = ""
  function addExplanation(newText) {
    let dt = new Date(Date.now())

    return (
      "<hr/><strong>日期：</strong>" +
      dt +
      "<br/><strong>解卦如下：</strong><br/><my_explanation>" +
      newText +
      "</my_explanation>"
    )
  }

  // Update guaRecordStore (localStorage)
  function updateGuaRecordStore(firebaseUid) {
    // console.log(
    //   "@ HandQi.updateGuaRecordStore: Updatng GuaRecordStore for firebaseUid: " +
    //     firebaseUid
    // )

    let guaRecords = []
    let guaCount = 0
    db.collection("guaRecords")
      .where("firebaseUid", "==", firebaseUid)
      .get()
      .then((querySnapshot) => {
        guaCount = 0
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          guaCount++
          let tmpArray = doc.data()
          tmpArray.show = true
          tmpArray.id = doc.id
          guaRecords.push(tmpArray)
        })
        // sort the guaRecords per recordDT as default sort.
        //  console.log("@ Record: before sort guaRecords = ", guaRecords)
        guaRecords.sort((a, b) => (a.recordDT < b.recordDT ? 1 : -1))
        //  console.log("@ Record: after sort guaRecords = ", guaRecords)

        // currentUserGuaCount.set(guaCount)
        // $userStore.guaCount = guaCount
        // $userStore.guaRecords = [...guaRecords]
        $guaRecordStore = JSON.stringify(guaRecords)
        $userGuaCount = guaCount
        // console.log(
        //   "@ HandQi.updateGuaRecordStore: guaCount in $userGuaCount is updated = " +
        //     $userGuaCount
        // )
        // console.log(
        //   "@ Record: $userStore.guaRecords = ",
        //   $userStore.guaRecords
        // )
        // console.log(
        //   "@ HandQi.updateGuaRecordStore: +++ the refreshed JSON.parse($guaRecordStore) = ",
        //   JSON.parse($guaRecordStore)
        // )
        //location.assign("/records")
      })
      .catch(function (error) {
        console.log(
          "@ HandQi.updateGuaRecordStore: Error getting guaRecords documents: ",
          error
        )
      })
  }

  // **** Handle Submit ****
  let myComment = ""
  function handleSubmit() {
    if (pin.length == 6) {
      recordDT = Date.now()

      let dt = new Date(recordDT).toString()

      numStr = pin
      toGuaResult = pin
      guaNumbers = pin
      explanation = addExplanation(newExplanation)
      // newExplanation is teh text member typed in. Now need to build into explanation object
      // Only encrypt the content, not the date
      explanation = {
        dt: dt,
        content: AesCtr.encrypt(newExplanation, xiyiSalt, 256),
      }
      // console.log(
      //   "@ HandQi.handleSubmit: encrypted explanation is built: ",
      //   explanation
      // )
      // build the comment with time stape and HTML tags, etc.
      //comment.push(buildComment(dt, myComment))
      // comment is the an object array.  text member typed in. Now need to build into explanation object
      // Only encrypt the content, not the date
      comment.push({
        dt: dt,
        content: AesCtr.encrypt(myComment, xiyiSalt, 256),
      })
      // console.log(
      //   "@ HandQi.handleSubmit: encrypted comment is built: ",
      //   comment
      // )

      guaCount = $userGuaCount

      const encryptedQuestion = AesCtr.encrypt(question, xiyiSalt, 256)
      // console.log(
      //   "@ HandQi.handleSubmit: encrypted question is created: ",
      //   encryptedQuestion
      // )
      //const encryptedEXplanation = AesCtr.encrypt(explanation, xiyiSalt, 256)
      //const encryptedComment = AesCtr.encrypt(comment, xiyiSalt, 256)

      db.collection("guaRecords")
        .add({
          firebaseUid,
          qiGuaDT,
          recordDT,
          guaType,
          qiGuaPerson,
          recorder,
          // question,
          encryptionOn: true,
          question: encryptedQuestion,
          category,
          tag,
          guaNumbers,
          explanation,
          comment,
        })
        .then(() => {
          // console.log(
          //   "@ HandQi.handleSubmit: gua successfully added to firebase. Next is to update localStorage."
          // )
          updateGuaRecordStore(firebaseUid)
          //location.assign("/records")

          // prepInputSummary()
          guaSubmitted = true
          copy_qiGuaDT = qiGuaDT
          copy_qiGuaPerson = qiGuaPerson
          copy_guaNumbers = guaNumbers
          //copy_explanation = explanation
          copy_question = question
          copy_category = category
          copy_tag = tag
          copy_new_tag = new_tag
          copy_ranking = ranking
          //copy_comment = comment
          copy_pin = pin

          qiGuaDT = ""
          qiGuaPerson = ""
          guaNumbers = ""
          explanation = ""
          question = ""
          category = ""
          tag = []
          new_tag = ""
          tagAdded = false
          ranking = ""
          comment = []
          pin = ""
          // alert(`@ HandQi.handleSubmit: gua just submitted ${numStr}`)

          backToTop()
        })
    } else {
      guaSubmitted = false
      alert("6 digits required. illegal length : " + pin.length)
    }
  }

  function addTag() {
    tag.push(new_tag.toUpperCase())
    tagString = tag.toString()
    tagAdded = true

    // console.log("@ HandQi: a new tag added: " + new_tag)
    // console.log("@ HandQi: tag is now: " + tag.toString())
    // console.log("@ HandQi: tag length is: " + tag.length)

    new_tag = ""
  }

  // ************ NOTE for Datepicker ************
  // the datepicker will pick a date in UTC time.
  // So if I pick 2/18/2021 anytime in CA (UTC-0800),
  // then it will record it as Wed Feb 18 2021 00:00:00,
  // and show local time to me as Wed Feb 17 2021 16:00:00 GMT-0800 (Pacific Standard Time)
  // ==> 8 hours earlier from mid-night.
  // This is something to fix later. --> figure our local time zone, find the diff and
  // update the date data from datepicker.
</script>

<main>
  {#if guaSubmitted == false}
    <div class="hand-qi ">
      <div class="gua-input">
        <!-- <GuaForm /> -->
        <h4>請自行輸入爻數和起卦紀錄</h4>
        <p>請由初爻至上爻，依序輸入六位從 6 到 9 的數字。</p>
        <Keypad bind:value={pin} />
        <br />
        <!-- <div class="yao-view" style="color: {pin ? pinColor : '#ed8e87'}"> -->
        <div class="yao-view" style="color: {pinColor}">
          {#if pin.length == 6}
            <h2>{view}</h2>
          {:else}
            <h4>{view}</h4>
          {/if}
        </div>
      </div>
      <div id="hand-input-form">
        <form id="create-form" on:submit|preventDefault={handleSubmit}>
          <br />
          <div class="">
            <label for="qiGuaDate">* 起卦日期</label>
            <input
              id="qiGuaDate"
              type="datetime-local"
              class="datepicker"
              bind:value={qiGuaDT}
            />
          </div>
          <div class="input-user">
            <label for="qiGuaPerson">* 起卦人</label>
            <input
              id="qiGuaPerson"
              type="text"
              bind:value={qiGuaPerson}
              placeholder={qiGuaPerson}
            />
          </div>
          <div class="category">
            <label>* 問事類別： </label>
            {#each categories as item}
              <label class="cat-item">
                <input type="radio" bind:group={category} value={item} />
                <span class="checkbox-spacing">{item}</span>
              </label>
            {/each}
            <br /><br /><span class="blue-text darken-2"
              ><strong>
                {category == "" ? "" : "選定類別: " + category}</strong
              ></span
            >
          </div>
          <br />
          <div class="tag-field">
            <label>您也可以加入額外標記(tags)，以便自己將來搜尋卦例：</label>
            <input type="text" bind:value={new_tag} />
            <button on:click|preventDefault={addTag} class={btn_style_yellow_d2}
              >加入標記</button
            >
            <br /><br /><span class="blue-text darken-2"
              ><strong>
                {tagAdded ? "已加入的額外標記： " + tagString : ""}
              </strong></span
            >
            <br />
          </div>
          <br />
          <div class="input-field">
            <input id="question" type="text" bind:value={question} />
            <label for="question">* 問題</label>
          </div>
          <div class="markdown-text">
            <label for="markdown">試解卦</label>
            <textarea
              bind:value={newExplanation}
              placeholder="Enter explanation text here"
            />
          </div>
          <div class="markdown-text">
            <label for="myComment">筆記</label>
            <textarea bind:value={myComment} placeholder="Enter comment here" />
          </div>
          <br />
          <button
            disabled={pin.length != 6 || !requiredFieldReady}
            class="btn btn-large waves-effect waves-light blue darken-2 z-depth-0"
            >輸入卦例</button
          >
        </form>
      </div>
    </div>

    <br />
  {:else}
    <hr />
    <div class="hand-result">
      <!-- <div id="gua-input">
        <h4>起卦輸入資料</h4>
        <p>
          {#each summaryObj as item}
            {item.title} : {item.data} <br />
          {/each}
        </p>
      </div> -->
      <div class="gua-result" id="show-handqi">
        <h4>您已輸入一卦：{numStr} :</h4>
        <h6>
          起卦人： {copy_qiGuaPerson} <br />
          起卦日期, {new Date(copy_qiGuaDT)}
        </h6>
        <hr />
        <GuaSummary {numStr} question={copy_question} {sectionName} {isLogin} />
      </div>
    </div>
  {/if}
</main>

<style>
  .hand-qi {
    background-color: #ffffff;
  }

  .yao-view {
    display: flex;
    justify-content: center;
    align-items: center;
    border-style: solid;
    border-color: #1e6bcf;
    border-radius: 25px;
    height: 90px;
  }
  .checkbox-spacing {
    padding-left: 25px;
    padding-right: 25px;
  }
  .cat-item {
    border-left: 2px solid;
    padding-left: 10px;
  }
</style>
